/** @module MaterialSpecProductSpec/SeasonColorMaterialAvailabilityRenderer */
define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/heading/Boolean"
], function(declare,_,BooleanRen) {

	return declare(BooleanRen, {

		/**
		 * @override
		 * Disable filtering
		 * @param {Context} ctx
		 * @param {Heading} h
		 * @param {Spec} spec
		 */
		getQuerySpec: function(ctx, h, spec) {
			return null;
		},

		_getValue: function(ctx, h) {
			var seasonUrl = ctx.view.getViewURL();
			var colorMaterial = ctx.getNode();
			var materialSeasonAvailabilities = ctx.cache.getPathNodes(colorMaterial, "Child:__Parent__/Child:Spec/Child:SeasonAvailability");
			var material = ctx.getParent();

			// The MaterialSeasonAvailability node
			var thisMaterialAvailability = _.find(materialSeasonAvailabilities, function(m) { return (seasonUrl == m.AvailabilitySeason); });
			if(!thisMaterialAvailability) {
				return false;
			}

			var colorMaterialUrl = ctx.getNodeURL();
			var availableDefault = thisMaterialAvailability.AvailabilityDefault;
			var isColorException = _.contains(thisMaterialAvailability.AvailabilityColorExceptions, colorMaterialUrl);
			var isSizeException = _.contains(thisMaterialAvailability.AvailabilityPairColorExceptions, colorMaterialUrl);

			var allSizesException = false;
			if (isSizeException && material.ProductSizes && material.ProductSizes.length > 0) {
				var colorMaterialSizeExceptions = _.filter(thisMaterialAvailability.AvailabilityPairColorExceptions, function(sizeException) {
					return sizeException == colorMaterialUrl;
				});

				allSizesException = colorMaterialSizeExceptions.length == material.ProductSizes.length;
			}

			return (availableDefault && (!isColorException || isSizeException) || !availableDefault && (isColorException || isSizeException)) && !allSizesException;
		}

	});
});